
import React, { useRef, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import TypingText from './TypingText';
import SEO from '../SEO';
import Footer from './Footer';
import Header from './Header';

const SponsershipDisclaimer = () => {

  const [showContactInfo, setShowContactInfo] = useState();
  useEffect(() => {
    window.scrollTo(0, 0); // scrolls to top when component mounts
  }, []);
  const hasRun = useRef(false);

  useEffect(() => {
    const navbar = document.getElementById("navbar");

    const media = window.matchMedia("(width <= 1024px)");

    function updateNavbar(e) {
      const isMobile = e.matches;
      const menu_div = document.getElementById("mob_menu");
      if (isMobile) {
        menu_div.style.display = "block";
        navbar.setAttribute("inert", "");
      } else {
        menu_div.style.display = "none";
        navbar.removeAttribute("inert");
      }
    }

    media.addEventListener("change", updateNavbar);
    updateNavbar(media);

    return () => media.removeEventListener("change", updateNavbar);
  }, []);




  const openSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");


    navbar.classList.add("show");
    openButton.setAttribute("aria-expanded", "true");
    openButton.style.display = "none";
    navbar.removeAttribute("inert");
  };

  const closeSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");

    if (openButton.getAttribute('aria-expanded') === 'true') {


      navbar.classList.remove('show');
      openButton.setAttribute('aria-expanded', 'false');
      openButton.setAttribute('style', 'display: block;');
      navbar.setAttribute('inert', '');

    }
  };



  return (

    <div className='w-screen h-full'>

      <Header></Header>


      <div id="overlay" aria-hidden="true"></div>


      <div className="tchead">
        <div className="tcinhead">
          <div style={{ textAlign: "center" }}>
            <h1>
            <b>
              Sponsorship Disclaimer</b>
              </h1>
              <br /><br />
          </div>

          AlgoController.com may display the names, logos, or information about our partners and sponsors. These sponsorships are intended to acknowledge their support or collaboration with our platform.
          <br /><br />
          <b>No Endorsement</b><br />
          &nbsp;&nbsp;&nbsp; * The inclusion of sponsor details on our website does not constitute an endorsement of their products, services, or business practices. Visitors should exercise their own discretion before engaging with any sponsor.
          <br /><br />
          <b>Information Accuracy</b><br />
          &nbsp;&nbsp;&nbsp; * While we aim to provide accurate sponsor information, AlgoController.com is not responsible for verifying or updating third-party content or claims.
          <br /><br />
          <b>No Commercial Advertisements</b><br />
          &nbsp;&nbsp;&nbsp; * We do not host paid advertisements on our platform. Sponsor recognition is for partnership transparency or informational purposes only.
          <br /><br />
          <b>Limited Liability</b><br />
          &nbsp;&nbsp;&nbsp; * AlgoController.com is not liable for any direct or indirect losses or issues arising from your interaction with any sponsors listed on the site.
          <br /><br />
          <b>Independent Evaluation Encouraged</b><br />
          &nbsp;&nbsp;&nbsp; * We recommend users independently verify sponsor credentials, offerings, and policies before initiating any transactions or relationships.



          <br /><br />
        </div>
      </div>

      <br></br>



      <div id="myModal" className="modal">
        <div className="modal-content">
          <span className="close">&times;</span>
          <h2>Hello!</h2>
          <p><b>We’re working hard behind the scenes to bring something great!</b><br />
            Some features and links will be available soon.<br />
            Thank you for your patience — our website is currently under construction.</p>
        </div>
      </div>

      <br /><br />

      <Footer></Footer>

    </div>

  )
}

export default SponsershipDisclaimer